"use client";
import React, { useState } from "react";
import { SectionDivider } from "app/components/shared/SectionDivider";
import { Box, Button, Flex } from "@chakra-ui/react";
import CloudHostedTables from "app/pricing/hostedEmulatorsTable/cloudHosted";
import BareMetalClusterTable from "app/pricing/hostedEmulatorsTable/bareMetalCluster";
import BareMetalTables from "app/pricing/hostedEmulatorsTable/bareMetal";

const EveNgPricing = () => {
  const [selectedOption, setSelectedOption] = useState("Cloud Instances");
  const handleClick = (option) => {
    setSelectedOption(option);
  };
  return (
    <Box data-cy="section-pricing" id="section-pricing">
      <SectionDivider label={"EVE-NG Pricing Options"} />
      <Flex
        direction={{ base: "column", md: "row" }}
        gap={"15px"}
        justifyContent={"center"}
      >
        <Button
          onClick={() => handleClick("Cloud Instances")}
          width={{ base: "100%", md: "30%" }}
          height={"55px"}
          color={selectedOption === "Cloud Instances" ? "black" : "white"}
          bgColor={selectedOption === "Cloud Instances" ? "#E2E8F0" : "blue.400"}
          _hover={{}}
        >
          <Flex direction={"column"}>
            <Box fontSize={"18px"}>Cloud Instances</Box>
            <Box fontSize={"14px"} fontWeight={"400"}>
              Save 15%(With Annual Billing)
            </Box>
          </Flex>
        </Button>
        <Button
          onClick={() => handleClick("Baremetal")}
          width={{ base: "100%", md: "30%" }}
          height={"55px"}
          color={selectedOption === "Baremetal" ? "black" : "white"}
          bgColor={selectedOption === "Baremetal" ? "#E2E8F0" : "blue.400"}
          _hover={{}}
        >
          <Flex direction={"column"}>
            <Box fontSize={"18px"}>Baremetal</Box>
            <Box fontSize={"14px"} fontWeight={"400"}>
              Save 15%(With Annual Billing)
            </Box>
          </Flex>
        </Button>
        <Button
          onClick={() => handleClick("Baremetal Cluster")}
          width={{ base: "100%", md: "30%" }}
          height={"55px"}
          color={selectedOption === "Baremetal Cluster" ? "black" : "white"}
          bgColor={selectedOption === "Baremetal Cluster" ? "#E2E8F0" : "blue.400"}
          _hover={{}}
        >
          <Flex direction={"column"}>
            <Box fontSize={"18px"}>Baremetal Cluster</Box>
            <Box fontSize={"14px"} fontWeight={"400"}>
              Save 15%(With Annual Billing)
            </Box>
          </Flex>
        </Button>
      </Flex>
      {selectedOption === "Cloud Instances" && (
        <CloudHostedTables os={["CI-OS-EVE-NG-PRO", "CI-OS-EVE-NG-COM"]} />
      )}
      {selectedOption === "Baremetal" && (
        <BareMetalTables os={["BM-OS-EVE-NG-PRO", "BM-OS-EVE-NG-COM"]} />
      )}
      {selectedOption === "Baremetal Cluster" && <BareMetalClusterTable />}
    </Box>
  );
};

export default EveNgPricing;
